exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatarImg[data-v-64b5759b] {\n  height: 40px;\n}\n.my-box .el-row[data-v-64b5759b] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-64b5759b]:last-child {\n    margin-bottom: 0;\n}\n.my-box .el-col[data-v-64b5759b] {\n  border-radius: 4px;\n}\n.my-box .my-input[data-v-64b5759b] {\n  max-width: 209px;\n}\n.checkBox[data-v-64b5759b] {\n  display: inline-block;\n  width: 28%;\n}\n", ""]);

// exports
